import React, { useRef, useState, useEffect } from 'react';

/**
 * 视频加载组件 - 只有当视频可以播放时才显示
 * @param {string} className - 视频元素的CSS类名
 * @param {string} src - 视频源地址
 * @returns {JSX.Element} 视频组件
 */
const LoadVideo = ({ className, src }) => {
  const videoRef = useRef(null);
  const [canPlay, setCanPlay] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleCanPlay = () => {
    setCanPlay(true);
    setHasError(false);
  };
  const handleError = () => {
    setHasError(true);
    setCanPlay(false);
  };
  const handleLoadStart = () => {
    setCanPlay(false);
    setHasError(false);
  };
  useEffect(
    () => {
      if (!src || !videoRef.current) return;

      const video = videoRef.current;
      video.addEventListener('canplay', handleCanPlay);
      video.addEventListener('error', handleError);
      video.addEventListener('loadstart', handleLoadStart);

      return () => {
        video.removeEventListener('canplay', handleCanPlay);
        video.removeEventListener('error', handleError);
        video.removeEventListener('loadstart', handleLoadStart);
      };
    },
    [src]
  );

  if (!src) return null;
  if (hasError) return null;

  return <video ref={videoRef} className={className} src={src} autoPlay loop muted style={{ display: canPlay ? 'block' : 'none' }} />;
};

export default LoadVideo;
